import React, { useEffect } from 'react';
import burgerIconBlack from '../../resources/burger_icon.png'
import burgerIconWhite from '../../resources/burger_icon_white.png'
import navigateTo from '../functions/navigateTo'
import closeIcon from '../../resources/close_icon.png'

const Navbar = () => {
  const ids = ['team', 'objective', 'project', 'model', 'conclusion', 'contacts']

  var shown = 0;
  var index = 0;

  const handleKeyPress = (event) => {

    if (event.key === 'ArrowUp') {
      if(index > 0){
        index--;
        navigateTo(ids[index]);
      }
    } else if (event.key === 'ArrowLeft') {
      if(index > 0){
        index--;
        navigateTo(ids[index]);
      }
    } else if (event.key === 'ArrowDown') {
      if(index < 6){
        index++;
        navigateTo(ids[index]);
      }
    } else if (event.key === 'ArrowRight') {
      if(index < 6){
        index++;
        navigateTo(ids[index]);
      }
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, []);

  const showMenu = () => {
    shown = (shown === 0 ? 1 : 0);
    document.getElementById('navbar').style.visibility=(shown === 0 ? 'visible' : 'hidden');
  }

  return (
    <div>
      <div className='navbar' id='navbar'>
        <p className='navbar__item' onClick={ () => navigateTo('team') }><u>Chi siamo</u></p>
        <p className='navbar__item' onClick={ () => navigateTo('objective') }><u>Obiettivo</u></p>
        <p className='navbar__item' onClick={ () => navigateTo('project') }><u>Il Progetto</u></p>
        <p className='navbar__item' onClick={ () => navigateTo('model') }><u>Il Modello</u></p>
        <p className='navbar__item' onClick={ () => navigateTo('conclusion') }><u>Conclusioni</u></p>
        <p className='navbar__item' onClick={ () => navigateTo('contacts') }><u>Contattaci</u></p>
      </div>
      <div className='burger' onClick={ () => showMenu()}>
          <img id='whiteIcon' className='burgerIcon' src={burgerIconWhite}></img>
          <img id='blackIcon' className='burgerIcon' src={burgerIconBlack}></img>
      </div>

      <div id='navbar__information' className='navbar__information'>
        <p>Puoi usare le frecce per muoverti lungo le sezioni!</p>
        <img id='closeIcon' src={closeIcon} onClick = { () => document.getElementById('navbar__information').style.visibility='hidden'}></img>
      </div>
    </div>
  )
}

export default Navbar